import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M4 4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6h-9l-2-2H4z" }));
export default createSvgIcon(iconPath, "Folder");
//# sourceMappingURL=FolderIcon.js.map